import React, { useEffect, useState } from "react";
import { Chart } from "primereact/chart";
import { GetAds } from "../../../../../../../core/Services";
import { useAuth } from "../../../../../../../auth/core/AuthContext";

export default function ChartJ({ months }) {
  const { userData } = useAuth();
  const uniqueCustomerId = userData?.unique_id;
  const [viewVisitorData, setViewVisitorData] = useState(null);

  useEffect(() => {
    GetAds(uniqueCustomerId)
      .then((response) => {
        const data = response.data;

        const chartData = {
          labels: months.map((month) => month.name), // Ay isimleri
          datasets: [
            {
              label: "Tıklamalar",
              data: months.map((month) => {
                const item = data.find((d) => d.month === month.value);
                return item ? item.clicks : null;
              }),
              borderColor: "blue",
              backgroundColor: "transparent",
              tension: 0.4,
            },
            {
              label: "Gösterim Sayısı",
              data: months.map((month) => {
                const item = data.find((d) => d.month === month.value);
                return item ? item.shows : null;
              }),
              borderColor: "orange",
              backgroundColor: "transparent",
              tension: 0.4,
            },
          ],
        };
        setViewVisitorData(chartData);
      })
      .catch((error) => {
        console.log("ViewVisitor Hatası", error);
      });
  }, [uniqueCustomerId, months]);

  return (
    <div className="w-full">
      {viewVisitorData && (
        <Chart
          style={{ width: "100%", height: "22rem" }}
          type="line"
          data={viewVisitorData}
          options={{
            maintainAspectRatio: false,
            aspectRatio: 1.5, // Gerekirse ayarlayın
            plugins: {
              legend: {
                position: "bottom",
              },
            },
            scales: {
              x: {
                title: {
                  display: true,
                  text: "Aylar",
                },
              },
              y: {
                title: {
                  display: true,
                  text: "Sayı",
                },
              },
            },
          }}
        />
      )}
    </div>
  );
}
